import cart from '@ppcp/cart';
import product from '@ppcp/product';
import {getSetting} from '@ppcp/utils';
import {ProductController} from '@ppcp/controllers';
import Context from '@ppcp/context';
import GooglePayGateway from '../gateways/GooglePayGateway';

const settings = getSetting('ppcp_googlepay_data');
const productSettings = getSetting('productSettings');

const {disabled = false} = settings;

if (!disabled) {
    const gateway = new GooglePayGateway({
        id: 'ppcp_googlepay',
        cart,
        settings
    });

    const controller = new ProductController(product, {
        id: 'ppcp_googlepay',
        cart,
        context: new Context('product'),
        gateway,
        settings: {
            ...settings,
            product: productSettings
        }
    });

    controller.initialize();
}